import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg";
import { Form } from "../Form/Form";

export function Contact() {
  return (
    <Container id="contact">
      <header>
        <h2>Contact</h2>
        <p>
          If you want to talk to me, don't hesitate to call me or send me a
          message.
        </p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:ritz_ronald@yahoo.com">
            ritz_ronald@yahoo.com
          </a>
        </div>
        <div>
          <img src={phoneIcon} alt="Phone No" />
          <a href="tel:+38163574277">(+381) 063/574-277</a>
        </div>
      </div>
      <Form></Form>
    </Container>
  );
}
